import {
  useUpdateLocationAlarm,
  useTenantDetails,
} from '@hakimo-ui/hakimo/data-access';
import { LocationAlarm, StatusType } from '@hakimo-ui/hakimo/types';
import { StatusStepper } from '@hakimo-ui/hakimo/ui-elements';
import { toast, useUser } from '@hakimo-ui/hakimo/util';
import { useEffect, useState } from 'react';
import {
  mapStatusToStatusType,
  mapStatusTypeToLabelType,
} from '../../../shared/util/common';
import StatusAction from './status-action/StatusAction';

interface Props {
  alarm: LocationAlarm;
  isEdit: boolean;
  onChangeEditStatus: (status: boolean) => void;
  onStatusChange?: (status: StatusType) => void;
}

export function AlarmStatus(props: Props) {
  const { alarm, onStatusChange, onChangeEditStatus, isEdit } = props;
  const user = useUser();
  const { data: tenantDetails } = useTenantDetails(user.tenant.id);
  const [statusType, setStatusType] = useState(
    mapStatusToStatusType(alarm.status)
  );
  const labelType = mapStatusTypeToLabelType(statusType);

  useEffect(() => {
    setStatusType(mapStatusToStatusType(alarm.status));
  }, [alarm.status]);

  const mutation = useUpdateLocationAlarm(alarm.id, {
    onSuccess: () => {
      onChangeEditStatus(false);
      toast('Alarm status updated', { type: 'success' });
      onStatusChange && onStatusChange(statusType);
    },
  });

  const onChangeStatusType = (type: StatusType) => {
    setStatusType(type);
    onChangeEditStatus(true);
  };

  const onClose = () => {
    onChangeEditStatus(false);
    setStatusType(mapStatusToStatusType(alarm.status));
  };

  const onSubmit = (comment: string) => {
    mutation.mutate({ status: statusType, comment });
  };

  return (
    <div className="flex w-full items-center">
      {isEdit ? (
        <StatusStepper
          onSubmit={onSubmit}
          onClose={onClose}
          isSubmitInProgress={mutation.isLoading}
          useAlternativeOptions={
            tenantDetails?.config?.useAlternativeResolutionOptions
          }
        />
      ) : (
        <StatusAction
          statusType={statusType}
          labelType={labelType}
          onChange={onChangeStatusType}
        />
      )}
    </div>
  );
}

export default AlarmStatus;
